{
    "app.title": "M365 Personal Data Exporter",
    "app.tagline": "Export your own Microsoft 365 data straight to a folder on your computer.",
    "app.privacy": "Your data goes from Microsoft to your disk. Nothing passes through our servers.",
    "help.heading": "Help, FAQ & tips",

    "nav.continue": "Continue to export →",
    "nav.back": "← Sign-in & permissions",
    "nav.signInFirst": "Sign in above to continue.",

    "lang.label": "Language",
    "lang.fr": "Français",
    "lang.en": "English",

    "browser.unsupported.title": "This browser is not supported",
    "browser.unsupported.body": "The exporter needs Microsoft Edge or Google Chrome. It writes files directly to your disk using an API that Firefox and Safari do not provide.",
    "browser.unsupported.missing": "Missing capability: {feature}",
    "browser.feature.fsa": "File System Access",
    "browser.feature.idb": "IndexedDB",

    "auth.section": "Sign in",
    "auth.signIn": "Sign in with Microsoft",
    "auth.signOut": "Sign out",
    "auth.signingIn": "Signing in…",
    "auth.signedInAs": "Signed in as {name}",
    "auth.notSignedIn": "Not signed in.",
    "auth.consentNote": "Only your name and email are requested now. Each export module asks for its own permission when you choose it.",
    "auth.error": "Sign-in failed: {message}",
    "auth.cancelled": "Sign-in was cancelled.",
    "auth.notSignedInSummary": "Not signed in",
    "auth.bridge.working": "Completing sign-in…",
    "auth.bridge.error": "Sign-in could not be completed. You can close this window and try again.",

    "storage.section": "Destination folder",
    "storage.intro": "Choose the folder the export is written to. You will only be asked once — the folder is remembered between sessions.",
    "storage.pickFolder": "Choose folder…",
    "storage.chosen": "Writing to: {name}",
    "storage.none": "No folder chosen yet.",
    "storage.reconnect": "Reconnect folder",
    "storage.reconnectNeeded": "Permission to write to {name} needs to be granted again.",
    "storage.permissionDenied": "Permission to write to that folder was denied.",
    "storage.cancelled": "Folder selection was cancelled.",
    "storage.writeTest": "Write a test file",
    "storage.testWritten": "Wrote {name} ({bytes} bytes).",
    "storage.error": "Storage error: {message}",
    "storage.written": "Written to this folder so far: {size}",
    "storage.showFolder": "Show folder",
    "storage.freeSpace": "Make sure the destination drive has at least 5 GB free before starting an export. Browsers cannot read available disk space, so the exporter cannot warn you if the drive fills up mid-run.",

    "graph.throttled": "Microsoft Graph is rate-limiting the request. Retrying in {seconds}s…",

    "preflight.checking": "Checking…",
    "preflight.reachable": "Reachable",
    "preflight.blocked": "Blocked ({error})",
    "preflight.sizeKnown": "{items} items, ~{size}",
    "preflight.sizeUnknown": "{items} items (size not available)",
    "preflight.sizeBytesOnly": "~{size}",
    "preflight.error": "Check failed: {message}",

    "modules.section": "What to export",
    "setup.intro": "Tick everything you want, then approve access — one prompt covering exactly your selection. The connection is checked later, right before the export starts.",
    "setup.confirmedSummary": "Ready",
    "modules.unavailable": "Not yet available",
    "modules.signInFirst": "Sign in above first",
    "modules.noneSelected": "Nothing selected yet",
    "modules.selectedCount": "{count} selected",
    "modules.selectAll": "Select all",
    "modules.selectNone": "Select none",

    "module.teams.label": "Teams chats",
    "module.teams.description": "1:1, group and meeting conversations, with inline images",
    "module.teams.permission": "Read your chat messages",
    "module.mail.label": "Mail",
    "module.mail.description": "Your own mailbox, every folder",
    "module.mail.permission": "Read your mail and mailbox settings",
    "module.onedrive.label": "OneDrive",
    "module.onedrive.description": "Your personal OneDrive files",
    "module.onedrive.permission": "Read your files",
    "module.calendar.label": "Calendar",
    "module.calendar.description": "Your calendars and shared calendars",
    "module.calendar.permission": "Read your calendars",
    "module.contacts.label": "Contacts",
    "module.contacts.description": "Your contacts (main Contacts folder)",
    "module.contacts.permission": "Read your contacts",
    "module.tasks.label": "Tasks",
    "module.tasks.description": "Your Microsoft To Do lists",
    "module.tasks.permission": "Read your tasks",
    "module.onenote.label": "OneNote",
    "module.onenote.description": "Notebooks you can access",
    "module.onenote.permission": "Read your notebooks",

    "permissions.grant": "Approve access",
    "permissions.requesting": "Waiting for approval…",
    "permissions.needed": "Approval needed",
    "permissions.cancelled": "Approval was cancelled. Nothing can be exported until you approve access.",
    "permissions.error": "Approval failed: {message}",

    "console.current": "Current item",
    "console.total": "Total on disk",
    "console.session": "Downloaded this session",
    "console.progress": "Items",
    "console.progressValue": "{done} of {total}",
    "console.started": "Export started.",
    "console.chatDone": "{label} — {messages} messages, {size}",
    "console.chatNewMessages": "{label} — {messages} new message(s) found, {size}",
    "console.chatSkipped": "{label} — already exported, skipped",
    "console.paused": "Paused. Progress is saved.",
    "console.stopped": "Stopped. Progress is saved.",
    "console.consentNeeded": "Approval needed to continue.",
    "console.locked": "Another tab is already exporting to this destination.",
    "console.restoredModule": "{module}: {items} items, {size}",
    "console.folderDone": "{label} — {messages} new message(s), {size}",
    "console.folderSkipped": "{label} — no new messages",
    "console.onedriveFolder": "Folder created: {path}",
    "console.onedriveCheckpoint": "{files} files, {folders} folders so far ({size})",
    "console.taskListDone": "{label} — {tasks} task(s), {size}",
    "console.taskListSkipped": "{label} — no tasks",
    "console.calendarDone": "{label} — {events} event(s), {size}",
    "console.calendarSkipped": "{label} — no new events",
    "console.onenotePageDone": "{label} — {size}",
    "console.exportRestored": "Resumed view: {items} items, {size} already saved.",
    "console.exportFinished": "All done — {size} total.",



    "export.section": "Export",
    "export.intro": "Choose a destination folder, then run every module you selected — Start checks access first, then runs each one after another.",
    "export.runHeading": "Run",
    "export.start": "Start export",
    "export.resume": "Resume export",
    "export.pause": "Pause",
    "export.stop": "Stop",
    "export.grantAccess": "Approve access to continue",
    "export.noFolder": "Choose a destination folder first.",
    "export.noModules": "Choose what to export first.",
    "export.readySummary": "Ready to export",
    "export.notReadySummary": "Not ready yet",
    "export.incomplete": "This export is unfinished. Resume to continue from where it stopped.",
    "export.paused": "Paused. Resume when you are ready — nothing is lost.",
    "export.stopped": "Stopped. Your progress is saved and can be resumed later.",
    "export.permissionNeeded": "Permission is needed to continue. Choose Continue and approve access in the popup — the export resumes automatically afterward.",
    "export.checking": "Checking…",
    "export.checkingConnection": "Confirming the connection…",
    "export.checkingModule": "Checking access ({done} of {total}) — {module}",
    "export.checkingDone": "Access checks complete.",
    "export.done": "Export complete.",
    "export.error": "Export failed: {message}",
    "export.writeFailed": "Couldn't write to the destination folder. This can mean the drive is full, permission needs reconnecting, or the folder was moved or deleted. Check the folder, then choose Resume — nothing is lost.",
    "export.locked": "An export is already running in another tab for this destination. Wait for it to finish, then choose Resume.",
    "export.withErrors": "{count} item(s) had errors and will be retried when you resume.",
    "export.moduleStarting": "Starting {module}…",
    "export.moduleFinished": "{module} complete: {items} items, {size}.",
    "export.moduleFailed": "{module} failed: {message}. It will be retried when you resume.",
    "export.moduleUnavailable": "{module} isn't available yet — skipped.",

    "scan.heading": "Your data",
    "scan.intro": "One card per type. Open shows what's already exported to your folder; Scan lists what each type contains so you can pick exactly what to export (skip it to export everything you approved). The date filter applies to Teams and Mail only.",
    "scan.moduleNotSelected": "Not selected for export on the previous page.",
    "scan.run": "Scan my account",
    "scan.rescan": "Re-scan",
    "scan.scanning": "Scanning…",
    "scan.scanningModule": "Scanning {module}… ({done} of {total})",
    "scan.done": "Scan complete — pick what to export below.",
    "scan.error": "Scan failed: {message}",
    "scan.noModules": "Choose what to export on the previous page first.",
    "scan.notScanned": "Not scanned yet.",
    "scan.emptyModule": "Nothing found for this.",
    "scan.selectAll": "All",
    "scan.selectNone": "None",
    "scan.delete": "Delete from Microsoft",
    "scan.dateAfter": "After",
    "scan.dateBefore": "Before",

    "console.dateFilter": "{module} date filter: {after} to {before}.",
    "console.moduleDeselected": "{module} — nothing selected, skipped.",
    "console.folderEmptied": "The destination folder is empty — starting a fresh export from scratch.",

    "delete.prompt": "Permanently DELETE from your Microsoft account: {module}, {count} selected item(s) and their contents. This CANNOT be undone (your local export is kept). Type DELETE to confirm.",
    "delete.cancelled": "Deletion cancelled.",
    "delete.nothingSelected": "{module} — nothing selected to delete. Scan and tick what to remove first.",
    "delete.consentFailed": "Delete permission was not granted: {message}",
    "delete.started": "Deleting {module} from Microsoft…",
    "delete.progress": "Deleting… {count} removed",
    "delete.teamsDone": "Deleted {deleted} of your messages ({skipped} left — sent by others or already deleted).",
    "delete.mailDone": "Deleted {deleted} messages and {folders} folder(s).",
    "delete.withErrors": "{count} item(s) could not be deleted.",
    "delete.done": "Deletion complete.",
    "delete.error": "Deletion failed: {message}",

    "browse.open": "Open",
    "browse.notExported": "Not exported yet",

    "viewer.count": "{count} {unit}",
    "viewer.unit.teams": "conversations",
    "viewer.unit.mail": "messages",
    "viewer.unit.onedrive": "files",
    "viewer.unit.calendar": "events",
    "viewer.unit.contacts": "contacts",
    "viewer.unit.tasks": "tasks",
    "viewer.unit.onenote": "pages",
    "viewer.search": "Search…",
    "viewer.selectPrompt": "Select something on the left to view it here.",
    "viewer.emptyModule": "Nothing has been exported for this yet.",
    "viewer.noMatch": "Nothing matches your search.",
    "viewer.loading": "Loading…",
    "viewer.itemError": "This item couldn't be opened. It may have been moved or deleted from the folder.",
    "viewer.download": "Download {name}",

    "faq.heading": "FAQ",
    "faq.q.dataLocation": "Where does my data actually go?",
    "faq.a.dataLocation": "Every byte travels from Microsoft Graph, through your browser, straight to the folder you choose on your own computer. Nothing passes through or is stored on our servers.",
    "faq.q.browsers": "Which browsers and computers work with this tool?",
    "faq.a.browsers": "Microsoft Edge or Google Chrome on a desktop or laptop — Windows, macOS, Linux and ChromeOS all work equally well. Firefox and Safari don't provide the capability this tool needs to write files straight to your disk.",
    "faq.q.mobile": "Can I use this on my phone or tablet?",
    "faq.a.mobile": "No — it needs a desktop or laptop. No mobile browser can write files directly to your device the way this tool requires. On iPhone and iPad this applies to every browser, including Chrome and Edge: Apple requires them all to use Safari's engine underneath, so switching browsers there won't help.",
    "faq.q.perModuleConsent": "Why does each module ask for permission separately?",
    "faq.a.perModuleConsent": "Only the access needed for what you actually choose to export is requested, and only when you choose it — not everything up front.",
    "faq.q.interruption": "What happens if I close the tab or my computer sleeps mid-export?",
    "faq.a.interruption": "Nothing is lost beyond, at most, the single item that was mid-write. Come back, sign in, and start the same export again — it continues from where it left off rather than starting over.",
    "faq.q.permissionPopup": "Why was I asked to approve access partway through?",
    "faq.a.permissionPopup": "This is expected, not an error. It happens the first time a module needs a permission you haven't granted yet, or after a long-running session's sign-in reaches its time limit. Approve access again and the export continues from its last checkpoint.",
    "faq.q.repeatExport": "Does running the export again redo everything?",
    "faq.a.repeatExport": "No — items already written to your folder are remembered and are not re-downloaded or duplicated. Items that changed since (an edited message, a rescheduled event, an updated contact, page or file) are refreshed. For Teams chats, a later run also checks each conversation for new messages since your last export and adds only those.",

    "tips.heading": "Tips",
    "tips.emptyFolder": "Point the export at an empty folder so everything from this run is easy to find in one place.",
    "tips.keepTabOpen": "For a large export, keep the tab open, or add this site to your browser's \"never put to sleep\" list — see the setting under Edge/Chrome's system settings for sleeping tabs.",
    "tips.checkSpace": "Check available disk space yourself before starting — the browser cannot do this for you (see the notice under Destination folder).",
    "tips.samefolder": "Reuse the same destination folder across sessions so already-exported items are recognised rather than treated as new.",
    "tips.oneModuleAtATime": "Selected modules export one after another, not all at once — if something goes wrong, the console shows exactly which module was running at the time.",

    "error.notConfigured": "The app registration is not configured. Set VITE_MSAL_CLIENT_ID and rebuild.",
    "error.unknown": "An unexpected error occurred.",

    "common.retry": "Try again",
    "common.dismiss": "Dismiss",
    "common.bytes": "{value} B",
    "common.kb": "{value} KB",
    "common.mb": "{value} MB",
    "common.gb": "{value} GB"
}
